import * as ng from 'angular';
import { UiRights } from '../../../../../configuration';
import { AccountModelService } from '../../../../../services/account';
import { AuthContextService } from '../../../../../services/auth-context';
import { DepositModelService } from '../../../../../services/billing/deposit-model';

export class MoleculePanelSepaInfoController implements ng.IController {
    public static $inject: string[] = ['accountModel', 'depositModel'];
    public sepaPaymentAvailable = false;

    private isPrepaid: boolean;
    private userProfileIsIncomplete = false;
    private readonly incompleteProfileFlagKey = 'ShowCompleteAccountDataPanel';

    constructor(
        private accountModel: AccountModelService,
        private depositModel: DepositModelService
    ) {
        if (
            !AuthContextService.isRootOrCompanyAccount
            && AuthContextService.isGranted(UiRights.BIL_GET_DEPOSIT)
        ) {
            void this.depositModel.getDeposit()
            .then((res) => {
                this.isPrepaid = res.paymentType === 'prepaid';
            });
        }
    }

    public $onInit(): void {
        void this.accountModel.getOwnUserFlags(this.incompleteProfileFlagKey).then(
            (response) => {
                this.userProfileIsIncomplete = (response === 'true')
                    && !AuthContextService.isCurrentUserAccountComplete;
            }
        );
        this.depositModel.paymentMethodAvailability().then(
            (paymentMethodAvailability: {paymentMethod: string; available: boolean}[]) => {
                const availableMethods = paymentMethodAvailability
                    .filter((method) => method.available)
                    .map((method) => method.paymentMethod);

                if (availableMethods.some(
                    (method) => ['directdebit'].indexOf(method.toLowerCase()) >= 0
                )) {
                    this.sepaPaymentAvailable = true;
                }
            }
        );
    }

    /*
    * shows panel when sepa is available, customer is still paying prepaid and user profile is complete
    */
    public get showSepaPanel(): boolean {
        return this.sepaPaymentAvailable && this.isPrepaid && !this.userProfileIsIncomplete;
    }
}

export class MoleculePanelSepaInfoComponent implements ng.IComponentOptions {
    public controller =  MoleculePanelSepaInfoController;
    public template = require('./panel-sepa-info.html');
}
